export const colorIndexesByPalleteForecast = {
  green: [12, 7, 16, 14, 28, 17, 15],
  blue: [5, 0, 34, 15, 18, 6, 14],
  red: [5, 0, 13, 34, 8, 17, 15],
  blueGreen: [0, 5, 6, 28, 24, 17, 15],
  blueRed: [34, 1, 0, 10, 11, 17, 15],
  blueYellow: [9, 29, 0, 34, 13, 17, 15],
};

export const colorIndexesPriceOverview = {
  green: [12, 7, 16, 14, 28],
  blue: [5, 0, 34, 15, 18],
  red: [5, 0, 13, 34, 8],
  blueGreen: [0, 5, 6, 28, 24],
  blueRed: [34, 1, 0, 10, 31],
  blueYellow: [9, 29, 0, 34, 13],
};

// TODO: нужно дождаться согласования цветов используемых ниже
// const colorIndexesMarketTrends = {
//   green: [12, 10, 7, 8, 16],
//   blue: [5, 0, 6, 15, 2],
//   red: [5, 0, 6, 16, 2],
//   blueGreen: [5, 0, 6, 17, 2],
//   blueRed: [1, 36, 0, 31, 2],
//   blueYellow: [29, 10, 0, 9, 35],
// };

export const colorIndexesMarketTrends = {
  green: [12, 10, 7, 8, 16],
  blue: [5, 10, 0, 6, 15],
  red: [5, 21, 0, 6, 16],
  blueGreen: [5, 10, 0, 28, 8],
  blueRed: [1, 10, 36, 8, 18],
  blueYellow: [29, 36, 10, 8, 9],
};

export const colorIndexesStructureDetails = {
  green: [12, 7, 16, 14, 34],
  blue: [5, 4, 0, 6, 15],
  red: [5, 21, 0, 13, 16],
  blueGreen: [5, 4, 0, 17, 8],
  blueRed: [1, 36, 8, 0, 11],
  blueYellow: [29, 10, 0, 9, 13],
};
